import { ChangeDetectionStrategy, ChangeDetectorRef, Component, inject, OnDestroy, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { IonContent, IonHeader, IonToolbar, IonButton, IonIcon, IonLabel, ModalController, IonFooter, IonNav, IonAvatar, ViewDidEnter, AlertController } from '@ionic/angular/standalone';
import { Group, KeyPoint, LocalData, Training } from '../app.types';
import { addIcons } from 'ionicons';
import { close, pause, play, playBack, playSkipBack, scan } from 'ionicons/icons';
import { environment } from 'src/environments/environment';
import { UtilsService } from '../utils.service';
import { ProgressBar } from 'primeng/progressbar'
import { AccordionModule } from "primeng/accordion"
import { QuizPage } from './quiz/quiz.page';
import { AuthService, TempoUser } from '../auth.service';
import { Capacitor } from '@capacitor/core';
import { ApiService } from '../api.service';
import { InstagramPostComponent } from '../components/instagram-post/instagram-post.component';

@Component({
  selector: 'app-training-video',
  templateUrl: './training-video.page.html',
  styleUrls: ['./training-video.page.scss'],
  standalone: true,
  imports: [IonAvatar,
    IonFooter, IonLabel, IonIcon, IonButton, IonContent,
    IonHeader, IonToolbar, CommonModule, FormsModule, ProgressBar, AccordionModule, InstagramPostComponent
  ]
})
export class TrainingVideoPage implements OnInit, ViewDidEnter, OnDestroy {


  auth = inject(AuthService)
  utils = inject(UtilsService)
  api = inject(ApiService)

  t: Training
  tvideo!: HTMLVideoElement
  localData!: LocalData
  progress = 0
  playIcon = "play"
  speedIndex = 0
  speedLabels = ["1x", "1.5x", "2x"]
  supposedCurrentTime = 0
  allowSeeking = false
  initializing = true
  quizReady = false

  user: TempoUser

  embGroup: Group

  instaTime = environment.production ? 30000 : 5000
  instaTimer: ReturnType<typeof setTimeout>

  constructor(
    public modalController: ModalController,
    private nav: IonNav,
    private alertController: AlertController
  ) {
    addIcons({ close, play, playBack, pause, playSkipBack, scan });
  }

  ngOnDestroy(): void {
    if (this.instaTimer) {
      clearTimeout(this.instaTimer)
    }
  }

  ionViewDidEnter(): void {
    //this.changeDetector.detectChanges()
  }

  async ngOnInit() {

    this.user = this.auth.getUser()
    console.log("TrainingVideoPage ngOnInit user", this.user)
    this.utils.getLocalData(this.t, this.user?.uid).then(async (ld) => {
      this.localData = ld
      console.log("Saved position", this.localData.elapsed)

      const iptime = await this.getVideoDuration(this.t.video_url)
      console.log("Video duration", iptime)
      if (environment.production) {
        this.instaTime = Math.round(iptime) * 1000
      }

      if (this.t.instagram_url && this.localData.elapsed >= this.instaTime) {
        console.log("Skip insta timer")
        this.localData.elapsed = this.instaTime
        this.ended()
      } 
      
      if (this.localData.videoCompleted) {
        console.log("Video completed...")

        this.instaTimer = setTimeout(() => {
          this.ended()
        }, 2000)
      }
    }).catch((err) => {
      console.log("Error getting local data TrainingVideoPage", err)
    })

    console.log("emb group", this.embGroup.name)
    if (Capacitor.isNativePlatform() && !this.embGroup) {
      this.embGroup = this.user.selectedGroup
    }

    if (this.embGroup) {
      this.auth.embGroup = this.embGroup
    }

    // if(this.t.instagram_url) {
    //   const res = await this.api.getInstagramPostData(this.t.instagram_url)
    //   //console.log("getInstagramPostData",res)
    // }

  }

  isWeb() {
    return !Capacitor.isNativePlatform()
  }

  hasControls() {
    return false
  }

  loadedmetadata(e: Event) {
    console.log("Video meta loaded")
    if (e.target && !this.tvideo) {
      this.tvideo = e.target as HTMLVideoElement

      if (this.localData.elapsed != 0) {
        this.allowSeeking = true
        this.tvideo.currentTime = this.localData.elapsed
        if (this.tvideo.currentTime == this.tvideo.duration) this.ended()
      }
      this.progress = this.tvideo.currentTime / this.tvideo.duration * 100
      this.supposedCurrentTime = 0
      this.updateKeypoints()

      setTimeout(() => {
        console.log("End initializing")
        this.initializing = false
      }, 3000)
    }

  }

  loadeddata(e: Event) {
    if (this.initializing) return
    console.log("loadeddata...")
    if (e.target && !this.tvideo) {
      this.tvideo = e.target as HTMLVideoElement
    }
  }

  play() {
    console.log("play...")
    if (!this.tvideo.paused) {
      this.tvideo.pause()
    } else {
      this.tvideo.play()
    }
  }

  changeSpeed() {
    this.speedIndex += 1
    if (this.speedIndex >= this.speedLabels.length) this.speedIndex = 0
    if (this.speedIndex == 0) {
      this.tvideo.playbackRate = 1
    }
    else if (this.speedIndex == 1) {
      this.tvideo.playbackRate = 1.5
    }
    else if (this.speedIndex == 2) {
      this.tvideo.playbackRate = 2
    }

  }

  rewind() {
    if (this.tvideo.currentTime >= 5) {
      this.tvideo.currentTime -= 5
    } else {
      this.tvideo.currentTime = 0
    }
  }

  begin() {
    console.log("begin...")
    this.tvideo.currentTime = 0
  }

  timeupdate() {
    if (this.initializing) return
    if (!this.tvideo.seeking) {
      this.supposedCurrentTime = this.tvideo.currentTime
    }



    this.localData.elapsed = this.tvideo.currentTime
    this.progress = this.tvideo.currentTime / this.tvideo.duration * 100
    this.updateKeypoints()

    if(this.tvideo.currentTime >= (this.tvideo.duration-4) && !this.localData.videoCompleted) {
      this.ended()
    }
  }

  seek(time: number) {
    if (this.localData.videoCompleted) {
      this.tvideo.currentTime = time
    }
  }

  seeking() {
    if (this.initializing) return
    if (this.allowSeeking || this.localData.videoCompleted || !environment.production) {
      this.allowSeeking = false
      return
    }

    const delta = this.tvideo.currentTime - this.supposedCurrentTime
    if (delta > 0.01) {
      this.tvideo.currentTime = this.supposedCurrentTime
    }
  }

  async ended() {
    if(this.localData.videoCompleted) return
    //console.log("ended: elapsed",this.localData.elapsed, "current", this.tvideo.currentTime)
    this.localData.videoCompleted = true
    this.localData.elapsed = this.t.instagram_url ? this.instaTime : this.tvideo.currentTime
    await this.utils.saveLocalData(this.t.tid!, this.user?.uid, this.localData)
    this.supposedCurrentTime = 0

    this.quizReady = true

    if (!this.localData.accepted) {
      setTimeout(() => {
        this.utils.setFocus("quiz_button")
      }, 1000)

      setTimeout(() => {
        this.utils.setClasses("quiz_button", ["bounce", "button-primary-bg"])
      }, 2000)
    }

  }

  async getVideoDuration(url: string): Promise<number> {
    return new Promise((resolve, reject) => {
      const video = document.createElement('video')
      video.preload = 'metadata'

      video.onloadedmetadata = () => {
        window.URL.revokeObjectURL(video.src)
        resolve(video.duration)
      }

      video.onerror = (err) => {
        reject(new Error('Failed to load video metadata: ' + url))
      }

      video.src = url
    })
  }

  kpdone(kp: KeyPoint) {
    if (this.localData && this.localData.videoCompleted) {
      return true
    }
    return kp.progress > 99
  }

  onplay() {
    console.log("onplay...")
    this.playIcon = "pause"
  }

  onpause() {
    console.log("onpause...")
    this.utils.saveLocalData(this.t.tid!, this.user?.uid, this.localData)
    this.playIcon = "play"
  }

  updateKeypoints() {
    if (!this.t.keypoint_data) return

    this.t.keypoint_data.forEach((kp) => {
      if (this.between(this.tvideo.currentTime, kp.begin!, kp.end!)) {
        kp.progress = (this.tvideo.currentTime - kp.begin!) / (kp.end! - kp.begin!) * 100
      }
      else if (this.tvideo.currentTime > kp.end!) {
        kp.progress = 100
      }
      else {
        kp.progress = 0
      }


    })
  }

  between(x: number, min: number, max: number) {
    return x >= min && x <= max;
  }

  kpVisible(kp: KeyPoint) {
    if (this.between(this.tvideo.currentTime, kp.begin, kp.end)) {
      return "block"
    }
    return "none"
  }

  async startQuiz() {
    //this.router.navigate(["quiz", this.t.tid])

    const ld = await this.utils.getLocalData(this.t, this.user?.uid)
    //console.log(JSON.stringify(ld,null,2))

    if (this.localData.accepted) {
      const alert = await this.alertController.create({
        message: "Hai già finalizzato questo contenuto e incassato i PT.",
        buttons: [
          {
            text: "OK"
          }
        ]
      })
      await alert.present()
      return
    }
    else if (!this.localData.videoCompleted) {
      const alert = await this.alertController.create({
        message: "Devi terminare la visione del video prima di accedere al quiz.",
        buttons: [
          {
            text: "OK"
          }
        ]
      })
      await alert.present()
      return
    }

    this.nav.push(QuizPage, {
      t: this.t,
      user: this.user
    })
  }

}
